
/**
 * @typedef { Object } CaptureLOCMappingDataPoints
 * @property { String } - All the object keys are strings and all the object values are strings.
 * @description The key is an existing data point the dom.
 * The value is the data point we want to replace the existing one with.
 */
const CaptureLOCMappingDataPoints = {
    "Account_2": "Account_1",
    "Account_5": "Account_1",
    "Account_9": "Account_0",
    "Account_9_label":"Account_0_label",   
    "Account_9_Name": "Account_0_Name",
    "Account_9_Balance_Label": "Account_0_Balance_Label",
    "Account_8": "Account_3",
    "Account_9_Select_Account_Item_Chevron": "Account_0_Select_Account_Item_Chevron",
    "Account_All_Entitlements_9__checkbox": "Account_All_Entitlements_0__checkbox",
    "Account_Name_Desktop_9" : "Account_Name_Desktop_0",
    "Account_Balance_Desktop_9" : "Account_Balance_Desktop_0",
    "Account_Number_Desktop_9" : "Account_Number_Desktop_0",
    "Account_Tile_View_Drag_Drop_Icon_9": "Account_Tile_View_Drag_Drop_Icon_0",
    "Account_Tile_View_Eye_Icon_9": "Account_Tile_View_Eye_Icon_0",
    "alert_message_7": "alert_message_0",
    "alert_message_9": "alert_message_2",
    "Amount_Total_64": "Amount_Total_2",
    "Back_Deposit_Check_4": "Back_Deposit_Check_0",
    "Checking_Account_9_selected_label": "Checking_Account_0_selected_label",
    "Chevron_Icon_64" : "Chevron_Icon_2",
    "Close_Deposit_4": "Close_Deposit_0",
    "Close_Transaction_64": "Close_Transaction_2",
    "deposit_account_4": "deposit_account_0",
    "deposit_amount_4": "deposit_amount_0",
    "deposit_Chevron_4": "deposit_Chevron_0",
    "deposit_date_4": "deposit_date_0",
    "deposit_status_4": "deposit_status_0",
    "Download_Page_Account_Option_9_label": "Download_Page_Account_Option_0_label",
    "Front_Deposit_Check_4": "Front_Deposit_Check_0",
    "Funding_Account_Select_Item_9": "Funding_Account_Select_Item_1",
    "notifi_alert_button_9": "notifi_alert_button_0",
    "notifi_alert_button_7": "notifi_alert_button_0",
    "notifi_amount_input_7": "notifi_amount_input_0",
    "notifi_amount_input_8": "notifi_amount_input_1",
    "notifi_toggle_7": "notifi_toggle_0",
    "notifi_toggle_8": "notifi_toggle_1",
    "notifi_toggle_9": "notifi_toggle_2",
    "Profile_All_Entitlements_1__checkbox": "Profile_All_Entitlements_0__checkbox",
    "Preference_9_0_label": "Preference_0_0_label",
    "Preference_9_1_label": "Preference_0_1_label",
    "Preference_9_2_label": "Preference_0_2_label",
    "Preferece_Select_9_Chevron": "Preferece_Select_0_Chevron",
    "Preferece_Select_5_Chevron": "Preferece_Select_1_Chevron",
    "Statement_Desktop_Item_5" : "Statement_Desktop_Item_0",
    "Start_Check_2": "Start_Check_0",
    "Toggle_Deposit_Check_4": "Toggle_Deposit_Check_0",
    "Transaction_Details_64": "Transaction_Details_2",
    "ViewCheck_64": "ViewCheck_2",
    "9_contactInfo_0": "0_contactInfo_0",
    "9_contactInfo_5": "0_contactInfo_5",
    "Mobile_Deposit_Chevron_63" :"Mobile_Deposit_Chevron_43",
    "Edit_Transfer_Link_63": "Edit_Transfer_Link_43",
    "Cancel_Transfer_Link_63": "Cancel_Transfer_Link_43",
    "One_Time_ACH_Offset_Account_Option_9_label":"One_Time_ACH_Offset_Account_Option_5_label",
    "Account_Name_mobile_9" : "Account_Name_mobile_0",
    "Account_Balance_mobile_9" : "Account_Balance_mobile_0",
    "Account_Number_mobile_9" : "Account_Number_mobile_0",   
    "Statement_mobile_Item_5" : "Statement_mobile_Item_0",
    "EDE_Statements_Account_9": "EDE_Statements_Account_0",
    "EDE_Statements_Account_View_Statement_9": "EDE_Statements_Account_View_Statement_0",
    "EDE_Statements_Account_History_9": "EDE_Statements_Account_History_0",
    "EDE_Statements_View_History_Item_9": "EDE_Statements_View_History_Item_0",
    "Preferece_Select_9": "Preferece_Select_0"
};

export default CaptureLOCMappingDataPoints;